import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Yuntu-index-1992f2b7bd73f4f56-1'),
    routerUrl: '/Yuntu',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Yuntu')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Yuntu-index-1992f2b7bd73f4f56-2'),
        routerUrl: '/YuntuRefillForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./YuntuRefillForm')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Yuntu-index-1992f2b7bd73f4f56-3'),
        routerUrl: '/YuntuRefill',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./YuntuRefill')),
      },
      //$MORE$
    ],
  },
];
